import { Component, ContentChildren, Input, QueryList } from "@angular/core";

@Component({
  selector: "snt-page-detail-header-line",
  template: "",
  standalone: false
})
export class PageDetailHeaderLine {
  @Input()
  icon: string = "";

  @Input()
  text: string | undefined | null;

  @Input()
  html: string | undefined;

  @ContentChildren(PageDetailHeaderLine)
  lines: QueryList<PageDetailHeaderLine>;
}
